module.exports = "/images/whats-new.png?898fbb19cf98900b72b4cf1fa5d47f44";